import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import mainServerClient from "../http/mainServerClient";

export enum UniversalOrderSettingType {
    ORDER_FLAG_LABEL = "ORDER_FLAG_LABEL",
    COPY_ORDER_INFO = "COPY_ORDER_INFO",
    ORDER_SORT_PRIORITIZATION = "ORDER_SORT_PRIORITIZATION",
    ORDER_SEARCH_PANEL = "ORDER_SEARCH_PANEL",
}

export interface UniversalOrderSetting {
    /**
     * 公司 ID。
     * <p>公司维度设置时有值，如跨店铺下的设置，如果是某个店铺的设置时只有 shopId 没有 companyId。
     */
    companyId?: number;
    /**
     * 创建时间
     */
    dateCreated?: string;
    id?: number;
    /**
     * 最后更新时间
     */
    lastUpdated?: string;
    /**
     * 订单列表 tab。
     */
    orderTab?: OrderTab;
    /**
     * 配置内容
     * <p>具体内容格式由前端决定，可以是简单字符串或 JSON 格式。
     */
    settingContent?: string;
    /**
     * 店铺 ID。
     * <p>店铺维度的设置时有值。
     */
    shopId?: number;
    /**
     * 配置类型。
     */
    type: UniversalOrderSettingType;
}

export interface GetUniversalOrderSettingListParams {
    companyId?: number;
    shopId?: number;
    orderTab?: OrderTab;
    type: UniversalOrderSettingType;
}

const formatType = (type: UniversalOrderSettingType) => type.toLowerCase();

// 查询指定类型的配置列表。
export function getUniversalOrderSettingList(params: GetUniversalOrderSettingListParams) {
    const { type, ...restParams } = params;
    return mainServerClient.get<UniversalOrderSetting[]>(
        `/universal_order_setting/${formatType(params.type)}/list`,
        restParams,
    );
}

export interface SaveUniversalOrderSettingParams {
    // 可选，为空时表示公司级别设置
    shopId?: number;
    orderTab?: OrderTab;
    type: UniversalOrderSettingType;
    settingContent: string;
}

export function saveUniversalOrderSetting(params: SaveUniversalOrderSettingParams, hideModal = false) {
    const { type, ...restParams } = params;
    return mainServerClient.post<UniversalOrderSetting>(
        `/universal_order_setting/${formatType(params.type)}/save`,
        restParams,
        { hideModal },
    );
}

export interface DeleteUniversalOrderSettingParams {
    id: number;
    type: UniversalOrderSettingType;
}

export function deleteUniversalOrderSetting(params: DeleteUniversalOrderSettingParams) {
    return mainServerClient.post<UniversalOrderSetting>(
        `/universal_order_setting/${formatType(params.type)}/delete/${params.id}`,
    );
}
